import { Box, styled } from '@mui/material';
import {
  APPROVAL_SECTION_GAP,
  InfoSectionTitle,
} from '@/components/Approval/@components/InfoSection';
import {
  APPROVAL_TABLE_BORDER,
  APPROVAL_TABLE_HEAD_BG,
} from '@/components/Approval/@components/ApprovalFormTable/styles';
import { TEXT_BUTTON_TONE_TOKENS } from '@/theme/buttonTokens';

export const ExternalLoanRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${APPROVAL_SECTION_GAP}px;

  & .approval-form-table th,
  & .approval-form-table td {
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
  & .approval-form-table td.align-right {
    font-variant-numeric: tabular-nums;
  }

  /* 만기일 열이 많으면 표만 가로 스크롤, 지급은행 열은 고정 */
  & .maturity-table {
    table-layout: auto;
  }
  & .maturity-table .col-bank {
    position: sticky;
    left: 0;
    z-index: 1;
    min-width: 120px;
    background-color: var(--dk-bg, #fff);
  }
  & .maturity-table th.col-bank,
  & .maturity-table .row-total td {
    background-color: ${APPROVAL_TABLE_HEAD_BG};
  }
  & .maturity-table .row-total td {
    font-weight: 600;
  }

  /* 은행 상자 테두리와 겹치는 표 바깥 선 제거 */
  & .bank-detail-table th:first-of-type,
  & .bank-detail-table td:first-of-type {
    border-left: 0;
  }
  & .bank-detail-table th:last-of-type,
  & .bank-detail-table td:last-of-type {
    border-right: 0;
  }
  & .bank-detail-table tbody tr:last-of-type td {
    border-bottom: 0;
  }
  & .bank-detail-table .col-no {
    width: 56px;
  }
  & .bank-detail-table .col-business-number {
    width: 128px;
  }
  & .bank-detail-table .col-amount {
    width: 160px;
  }
  & .bank-detail-table .col-date {
    width: 112px;
  }
  & .bank-detail-table .row-more td {
    height: 36px;
    padding: 0 12px;
  }
  & .bank-detail-table .row-subtotal td {
    background-color: ${APPROVAL_TABLE_HEAD_BG};
    font-weight: 600;
  }
`;

export const ExternalLoanSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ExternalLoanTitle = styled(InfoSectionTitle)``;

export const CardRow = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const BankCard = styled(Box)`
  flex: 1 1 160px;
  min-width: 0;
  padding: 12px 16px;
  border: 1px solid ${APPROVAL_TABLE_BORDER};
  border-radius: 8px;
  background-color: var(--dk-bg, #fff);

  &.is-total {
    flex: 1.4 1 220px;
    border-color: ${APPROVAL_TABLE_HEAD_BG};
    background-color: ${APPROVAL_TABLE_HEAD_BG};
  }
`;

export const CardLabel = styled('p')`
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: var(--dk-text-secondary, #6b7280);

  .is-total > & {
    color: ${TEXT_BUTTON_TONE_TOKENS.keyColor.color};
  }
`;

export const CardAmount = styled('p')`
  margin: 4px 0 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: var(--dk-text, #131313);
  font-variant-numeric: tabular-nums;

  .is-total > & {
    font-size: 20px;
    line-height: 28px;
    color: ${TEXT_BUTTON_TONE_TOKENS.keyColor.color};
  }
`;

export const BankPanel = styled(Box)`
  border: 1px solid ${APPROVAL_TABLE_BORDER};
  border-radius: 8px;
  overflow: hidden;
`;

export const BankHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 12px 0 16px;
  font-size: 14px;
  line-height: 20px;

  & > strong {
    font-weight: 600;
  }
  & > button {
    margin-left: auto;
  }
`;

export const BankHeaderMeta = styled('span')`
  font-size: 12px;
  line-height: 16px;
  color: var(--dk-text-secondary, #6b7280);
`;
